import bookRepository from './book-repository'
import userRepository from './user-repository'
import mypageRepository from './mypage-repository'
import sheetRepository from './sheet-repository'

const repositoryFactory = {
  /** ユーザー */
  user: userRepository,
  /** mypageデータ */
  mypage: mypageRepository,
  /** bookデータ */
  book: bookRepository,
  /** sheetデータ */
  sheet: sheetRepository,
}

export default repositoryFactory
